import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { BookKey, FolderOpen, Gift } from "lucide-react";
import { Badge, OfferTierBadge } from "./ui";

type DashboardWorkspaceNavProps = {
  active: "projects" | "bonuses" | "reseller";
  projectCount: number;
  cloudWorkspace: boolean;
  hasResellerRights?: boolean;
  actions?: ReactNode;
};

export function DashboardWorkspaceNav({
  active,
  projectCount,
  cloudWorkspace,
  hasResellerRights = false,
  actions,
}: DashboardWorkspaceNavProps) {
  return (
    <div className="studio-home-sidebar">
      <span className="app-sidebar__section-label">Workspace</span>
      <Link
        className={`studio-home-sidebar__item ${active === "projects" ? "is-active" : ""}`}
        to="/PaperKingdom/studio"
        aria-current={active === "projects" ? "page" : undefined}
      >
        <FolderOpen size={18} />
        <span>
          <strong>Projects</strong>
          <small>
            {projectCount} saved {cloudWorkspace ? "in your cloud workspace" : "on this device"}
          </small>
        </span>
        <Badge>{projectCount}</Badge>
      </Link>
      <Link
        className={`studio-home-sidebar__item ${active === "bonuses" ? "is-active" : ""}`}
        to="/PaperKingdom/bonuses"
        aria-current={active === "bonuses" ? "page" : undefined}
      >
        <Gift size={18} />
        <span>
          <strong>Bonuses</strong>
          <small>Your complete download vault</small>
        </span>
        <Badge>5</Badge>
      </Link>
      <Link
        className={`studio-home-sidebar__item ${active === "reseller" ? "is-active" : ""}`}
        to="/PaperKingdom/reseller-rights"
        aria-current={active === "reseller" ? "page" : undefined}
      >
        <BookKey size={18} />
        <span>
          <strong>Reseller Rights</strong>
          <small>{hasResellerRights ? "Your reseller licence" : "Unlock the reseller licence"}</small>
        </span>
        <OfferTierBadge sku="paper-kingdom-reseller" locked={!hasResellerRights} />
      </Link>
      {actions}
    </div>
  );
}
